export default __webpack_public_path__ + "f44655affef8ba1f7442f9bf27aa17a5.png";